import { type NotificationSchedule } from 'primary-schema';

import { type Common } from '../common.js';
import {
  type CloneResponse,
  type CloneValues,
  type CreateValues,
  type FindAllOptions,
  type ScheduleListEntry,
  type ScheduleWithTimings,
  type UpdateValues,
} from '../models/notification/schedule.js';
import { type PaginatedQueryOptions } from '../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../models/pagination/PaginationResponse.type.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/notification-schedules';
  }

  async findAll(options?: FindAllOptions): Promise<NotificationSchedule[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAllForList(options?: FindAllOptions): Promise<ScheduleListEntry[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/list`, options);
    return await this.common.getJSON(url);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<ScheduleListEntry>> {
    const url = this.common.constructPath(`${this.baseEndpoint}/list`, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<ScheduleWithTimings> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<ScheduleWithTimings> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async clone(id: string, values: CloneValues): Promise<CloneResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/clone`);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<ScheduleWithTimings> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
